import { Box, Stack } from '@mui/material';
import { FC } from 'react';
import { Page } from '../../Page';
import { ActivityDayGroupSkeleton } from './ActivityDayGroupSkeleton';

export const ActivityPageSkeleton: FC = () => {
    return (
        <Page back insetEnabled={false} edgeToEdge>
            <Box
                sx={{
                    height: '100%',
                    overflow: 'hidden',
                    bgcolor: 'var(--tg-theme-secondary-bg-color)',
                    px: 2,
                    pt: 'calc(var(--tg-viewport-content-safe-area-inset-top, 0px) + var(--tg-viewport-safe-area-inset-top, 0px) + 12px)',
                }}
            >
                <Stack gap={2}>
                    <ActivityDayGroupSkeleton itemCount={4} />
                    <ActivityDayGroupSkeleton itemCount={3} />
                </Stack>
            </Box>
        </Page>
    );
};
